import { HeaderCheckout } from './HeaderCheckout.components.styles';
import type { ProgressStepsProps } from 'ui/components/templates';

const HeaderCheckoutProgressSteps = ({ children, current }: ProgressStepsProps) => (
  <HeaderCheckout.Steps current={current}>{children}</HeaderCheckout.Steps>
);

export default HeaderCheckoutProgressSteps;
